/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteEmployeeRoleRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {DeleteEmployeeRoleResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const deleteEmployeeRole = (request: DeleteEmployeeRoleRequest, options?: CashRequestOptions) => post<DeleteEmployeeRoleRequest, DeleteEmployeeRoleResponse>("/2.0/cash/delete-employee-role", request, {...options, rejectOnError: true })